<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_customsBillNo') || '海关编号'"
            prop="customsBillNo"
          >
            <el-input
              v-model="formData.customsBillNo"
              :placeholder="
                $l('INDEX.form_placeholder_customsBillNo') || '请输入海关编号'
              "
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { listOrderCode: { type: Array, default: () => [] } },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        customsBillNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_customsBillNo') ||
              '请输入海关编号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const params = { listOrderCode: this.listOrderCode, ...this.formData }
      this.loadingOpen()
      const res = await this.$api
        .shipmentPackingOrderUpdateApi(params)
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status != 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      this.$emit('reload')
      this.$emit('close')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
